import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ILocation } from '@api/types'
import { LocationFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: { locations: ILocation[] }
  }
}

const mutateHandler = handleFetchResult<IPayload, ILocation[]>({
  handler: (data) => data.viewer.company.locations,
  name: 'Location',
})

export default function locations(): Promise<ILocation[]> {
  return client.gql.query({ query: locationsQuery }).then(mutateHandler)
}

export const locationsQuery = gql`
  query locations {
    viewer {
      company {
        locations {
          ...LocationFragment
        }
      }
    }
  }
  ${LocationFragment}
`
